<template>
  <main>

    <div class="container-fluid px-0">
      <div class="row">
        <div class="col-12">
          <div class="custom_page_header">
            <h2>{{$t('message.sft_terms')}}</h2>
            <p class="lead">{{$t('message.sft_terms_sec')}}</p>
          </div>
        </div>
      </div>

      <!-- Page Content -->
      <div class="row pt-2" id="termsContainer">
        <div class="col-12">
          <h4 class="headerunderline">{{$t('message.sft_terms_introduction')}}</h4>
          <p class="leads">
            {{$t('message.sft_terms_read')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_further')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_continuation')}} <span class="font-weight-bolder">/safetravel.today/</span>, {{$t('message.sft_terms_contmeans')}}
          </p>
        </div>

        <div class="col-12">
          <h4 class="headerunderline">{{$t('message.sft_terms_general')}}</h4>
          <p class="leads">
            {{$t('message.sft_terms_platform')}}
            <u>Safetravel.today</u> 
            {{$t('message.sft_terms_platform_based')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_goal')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_visitor')}}
            <span class="font-weight-bolder">{{$t('message.sft_terms_ppolicy')}}</span> {{$t('message.sft_terms_ppolicy_p')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_reserves')}}
          </p>
        </div>

        <div class="col-12">
          <h4 class="headerunderline">{{$t('message.sft_terms_intellect')}}</h4>
          <p class="leads">
            {{$t('message.sft_terms_trademark')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_allcontent')}} <span class="font-weight-bolder">/safetravel.today/</span>{{$t('message.sft_terms_legalregist')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_anycoping')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_udert')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_extremely_per')}}
          </p>
        </div>     
        
        <div class="col-12"> 
          <h4 class="headerunderline">{{$t('message.sft_terms_infoprod')}}</h4>
          <p class="leads">
            {{$t('message.sft_terms_commited_ac')}}
          </p>
        </div> 

        <div class="col-12">
          <h4 class="headerunderline">{{$t('message.sft_terms_resvisitor')}}</h4>
          <p class="leads">
            <b>4.1.</b> {{$t('message.sft_terms_vistuser')}}
          </p>
          <p class="leads">
            <u>{{$t('message.sft_terms_indicatively')}}</u>
          </p>
          <ul class="leads">
            <li>{{$t('message.sft_terms_indicativelylo')}}</li>
            <li>{{$t('message.sft_terms_indicativelylt')}}</li>
            <li>{{$t('message.sft_terms_indicativelylthr')}}</li>
          </ul>
          <p class="leads">
            <b>4.2.</b> {{$t('message.sft_terms_furassum')}}
          </p>
          <p class="leads">
            <b>4.3.</b> {{$t('message.sft_terms_theeuser')}}
          </p>
          <p class="leads">
            <b>4.4.</b> {{$t('message.sft_terms_theeuseres')}}
          </p>
          <p class="leads">
            <b>4.5.</b> <u>{{$t('message.sft_terms_theeuseer')}}</u>:
          </p>
          <p class="leads">
            {{$t('message.sft_terms_bearsthe')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_obligprevent')}}
          </p>
          <p class="leads">
            <b>4.6.</b> {{$t('message.sft_terms_userfullres')}}
          </p>
          <p class="leads">
            <b>4.7.</b> {{$t('message.sft_terms_userhastheres')}}
          </p>
        </div>

        <div class="col-12">
          <h4 class="headerunderline">{{$t('message.sft_terms_limitliab')}}</h4>
          <p class="leads">
            {{$t('message.sft_terms_comptranst')}}
          </p>
          <p class="leads">
            <b>5.1.</b> {{$t('message.sft_terms_ccompensate')}}
          </p>
          <p class="leads">
            <b>5.2.</b> {{$t('message.sft_terms_doesnotguar')}}
          </p>
          <p class="leads">
            <b>5.3.</b> {{$t('message.sft_terms_osprovides')}} <u>{{$t('message.sft_terms_osjustitis')}}</u>. {{$t('message.sft_terms_nocaseshall')}}
          </p>
          <p class="leads">
            <b>5.4.</b> {{$t('message.sft_terms_tcnotliable')}}
          </p>
          <p class="leads">
            <b>5.5.</b> {{$t('message.sft_terms_thprovisions')}}
          </p>
          <p class="leads">
            <b>5.6.</b> {{$t('message.sft_terms_incorrectduring')}}
          </p>
          <p class="leads">
            <b>5.7.</b> {{$t('message.sft_terms_notresdamage')}}
          </p>
          <p class="leads">
            <b>5.8.</b> {{$t('message.sft_terms_cnnotliab')}}
          </p>
          <p class="leads">
            <b>5.9.</b> {{$t('message.sft_terms_waaarrabt')}}
          </p>
        </div>

        <div class="col-12">
          <h4 class="headerunderline">{{$t('message.sft_terms_orders')}}</h4>
          <p class="leads">
            {{$t('message.sft_terms_orderspara')}}
          </p>
        </div>

        <div class="col-12">
          <h4 class="headerunderline">{{$t('message.sft_terms_priceelist')}}</h4>
          <p class="leads">
            {{$t('message.sft_terms_priceelisttext')}}
          </p>
        </div>

        <div class="col-12">
          <h4 class="headerunderline">{{$t('message.sft_terms_meethospayment')}}</h4>
          <p class="leads">
            {{$t('message.sft_terms_pppoptions')}}
          </p>
          <ul class="leads">
            <li>{{$t('message.sft_terms_pppoptionsa')}}</li>
            <li>{{$t('message.sft_terms_pppoptionsc')}}</li>
          </ul>
          <p class="leads">
            {{$t('message.sft_terms_pppoptionscaseab')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_shiiipingproc')}}
          </p>
        </div>

        <div class="col-12">
          <h4 class="headerunderline">{{$t('message.sft_terms_secoftr')}}</h4>
          <p class="leads">
            {{$t('message.sft_terms_secoftrtxt')}} <span class="font-weight-bolder">/safetravel.today/</span>.
          </p>
        </div>

        <div class="col-12">
          <h4 class="headerunderline">{{$t('message.sft_terms_prrtitle')}}</h4>
          <p class="leads">
            {{$t('message.sft_terms_prrtitlesuv')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_prrtitlesuvtxt')}}
          </p>
        </div>

        <div class="col-12">
          <h4 class="headerunderline">{{$t('message.sft_terms_withrettitle')}}</h4>
          <p class="leads">
            <b>11.1</b> {{$t('message.sft_terms_withrettext')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_withrettexta')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_withrettextb')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_withrettexttext')}} 
          </p>
        </div>

        <div class="col-12">
          <h4 class="headerunderline">{{$t('message.sft_terms_applicablelawtitle')}}</h4>
          <p class="leads">
            {{$t('message.sft_terms_applicablelawtxt')}} <u>{{$t('message.sft_terms_applicablelawtxtunder')}}</u>
          </p>
          <p class="leads">
            {{$t('message.sft_terms_whhentheweb')}} <span class="font-weight-bolder">/safetravel.today/</span> {{$t('message.sft_terms_whhenthewebexup')}}
          </p>
          <p class="leads">
            {{$t('message.sft_terms_formoreinfo')}} <a class="linkterms" href="mailto:customer-support@safetravel.today">customer-support@safetravel.today</a>
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  metaInfo: {
    title: 'Terms of Use | Safetravel.today - Making Travel Insurance Easy',
    meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { 
            name: 'description', 
            content: 'Read the Safetravel.today Terms of Use. Learn about the rules, conditions, and legal guidelines for using our travel insurance services.' 
        },
        { 
            name: 'keywords', 
            content: 'terms of use, terms and conditions, Safetravel.today, travel insurance rules, legal guidelines' 
        },
        { property: 'og:title', content: 'Safetravel.today - Terms of Use' },
        { property: 'og:description', content: 'Understand the rules and conditions for using Safetravel.today travel insurance services and platform.' },
        { property: 'og:image', content: 'https://safetravel.today/images/og-image.png' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index, follow' },
    ],
    script: [
      {
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Safetravel.today',
          url: 'https://safetravel.today',
          logo: 'https://safetravel.today/logo.png',
          sameAs: [
            'https://www.facebook.com/safetraveltoday',
            'https://www.linkedin.com/company/safe-travel',
            'https://x.com/safetraveltoday'
          ],
          description: 'Safetravel.today is a travel insurance company offering secure, flexible, and affordable coverage for safe journeys worldwide.'
        },
      },
    ],
  },
}
</script>